export interface BlockBounds {
  minBlockNumber: number;
  maxBlockNumber: number;
}

export interface ExchangeRateResponseDto {
  baseCurrency: string;
  baseCurrencySymbol: string;
  baseCurrencyDisplayPrecision: number;
  exchangeRates: ExchangeRateDto[];
}

export interface ExchangeRateDto {
  currencySymbol: string;
  currencyDisplayPrecision: number;
  exchangeRateToBase: number;
}

export interface SystemConfiguration {
  isSweepingEnabled: boolean;
}
